module.exports = { prefix: 'fas', iconName: 'minus', icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };


//////////////////
// WEBPACK FOOTER
// D:/$offices/project/housingnokakou/node_modules/@fortawesome/fontawesome-free-solid/faMinus.js
// module id = 21
// module chunks = 0